import flatpickr from "flatpickr";
import flatpickrLanguages from "flatpickr/dist/l10n";
import {ajax, debounced} from "./../utils";
import DeparturePoints from "../frontv2/DeparturePoint/DeparturePoints";
import { WidgetExtraCheckout } from "../frontv2/WidgetExtraCheckout";
import Modal from "../frontv2/Modal";

class BookingProcess {
  constructor() {
    this.wrapper = document.querySelector('.wrapper-booking');
    if(!this.wrapper){
      return;
    }

    this.isTicket = this.wrapper.hasAttribute('data-is-ticket');
    this.useGroupPricing = this.wrapper.hasAttribute('data-use-group-pricing');
    if(this.useGroupPricing){
      this.defaultGroupsPrices = JSON.parse(this.wrapper.dataset.groupsPrices);
      this.groupsPrices = this.defaultGroupsPrices;
    }

    this.datepicker = this.wrapper.querySelector('input[name=date]');
    this.mainLangIdName = this.isTicket ? 'lang_id' : 'main_lang_id';
    this.langOptions = this.wrapper.querySelectorAll(`[name=${this.mainLangIdName}]`);
    this.langIdHidden = this.isTicket ? null : this.wrapper.querySelector('#embed-booking-lang-id-hidden');
    this.adultspicker = this.wrapper.querySelector('input[name=seats_adult]');
    this.childrenpicker = this.wrapper.querySelector('input[name=seats_child]');
    this.infantsPicker = this.wrapper.querySelector('input[name=seats_infant]');

    this.adultPriceDisplays = this.wrapper.querySelectorAll('[data-price-adult]');
    this.childPriceDisplays = this.wrapper.querySelectorAll('[data-price-child]');
    this.infantPriceDisplays = this.wrapper.querySelectorAll('[data-price-infant]');

    this.experienceId = this.wrapper.dataset.experienceId;

    // if there are departure points
    this.departurePointsSection = this.wrapper.querySelector('#departure-points-section');
    this.hasDeparturePoints = this.wrapper.hasAttribute('data-departure-points-to-choose');
    const bookingPage = this.wrapper.closest('#booking-page');
    this.continueBtns = bookingPage ? bookingPage.querySelectorAll('.continue-booking-btn') : [];

    this.dateHeaders = this.wrapper.querySelectorAll('.date-header');
    this.nextDayDiv = this.wrapper.querySelector('#nextDay');
    this.timeslotsContainer = this.wrapper.querySelector('#slotsContainer');
    this.scrollToTimeSlotsContainer = false;
    this.slotsLoading = this.wrapper.querySelector('#slots-loading');
    this.slotChosen = this.wrapper.querySelector('input[name=slot]');
    this.slotId = this.wrapper.querySelector('input[name=slot_id]');
    this.bookingAuto = this.wrapper.querySelector('input[name=booking_auto]');

    this.visitorsNumber = this.wrapper.querySelector('#visitors-number');
    this.total = document.querySelector('.amount');
    // this.wrapperNotAvailableText = this.wrapper.querySelector('.experience-not-available-for-filters');
    // this.notAvailableText = this.wrapperNotAvailableText.querySelector('p');
    // this.session = JSON.parse(document.body.dataset.session);
    this.submit = this.wrapper.parentElement.querySelector('button[data-go-to-payment]');
    // this.rawPrice = 0;
    // this.offerGiftBtn = this.wrapper.querySelector("#gift-offer");
    this.currentIteration = 0;
    this.maxIterations = 12; //Check available slots on 1 year
    this.nextMonthAvailable = false;
    this.nextYearAvailable = false;
    this.ajaxRequestRunning = false;
    this.ajaxRequest = null;
    this.isFree = this.wrapper.dataset.isFree === 'true';
    this.calendarWrapper = this.wrapper.querySelector('#calendar-wrapper');

    this.cartRecap = document.querySelector('.widget-cart-recap');
    this.cartDateText = document.querySelector('#cart-date-text');
    this.cartLangText = document.querySelector('#cart-lang-text');
    this.cartVisitorsLines = document.querySelector('#cart-visitors-lines');
    this.cartTotalAmount = document.querySelector('#cart-total-amount');
    this.cartTotalVisitorLabel = document.querySelector('#cart-total-visitor-label');
    this.cartHostTotalLine = document.querySelector('#cart-host-total-line');
    this.cartHostTotalAmount = document.querySelector('#cart-host-total-amount');
    this.cartCurrencyNotice = document.querySelector('#cart-currency-notice');
    this.cartDepartureLine = document.querySelector('#cart-departure-line');
    this.cartDepartureLabel = document.querySelector('#cart-departure-label');
    this.cartDeparturePrice = document.querySelector('#cart-departure-price');
    this.selectedSlotLabel = null;
    this.selectedSlotLangSvg = null;
    this.selectedSlotLangName = null;

    const _this = this;
    this.debouncedUpdateFlatpickrWithNewPersons = debounced(500, () => {
      _this.updateFlatpickrWithNewPersons();
    });

    this.debouncedRefetchTimeslots = debounced(400, () => {
      if(_this.currentDate && _this.flatpickrDate){
        const selectedDate = _this.flatpickrDate.selectedDates[0];
        if(selectedDate) _this.updateTimeslots(selectedDate);
      }
    });

    this.loadLangPicker();

    // if(this.isTicket) this.setPrice();
    this.setPrice();

    if(this.isTicket){
      this.setContinueBtnsDisabled(false);
    }

    new WidgetExtraCheckout();

    this.initContinueButton();
    this.updateCartRecap();
  }

  loadLangPicker() {
    this.currentAdults = parseInt(this.adultspicker.value);
    this.currentChildren = this.childrenpicker ? parseInt(this.childrenpicker.value) : 0;

    this.maxPersons = this.adultspicker.max;

    this.setupEvents();

    if(!this.isTicket){
      let now = new Date();
      this.currentDate = null;
      this.currentDates = [];

      this.currentMonth = now.getMonth()+1;
      this.currentYear = now.getFullYear();

      this.defaultDate = now;

      const checkedMain = this.wrapper.querySelector(`[name=${this.mainLangIdName}]:checked`);
      if(checkedMain){
        this.currentLangId = checkedMain.value;
      }

      if(this.langIdHidden){
        if(this.currentLangId === 'any'){
          this.langIdHidden.value = '';
        }
        else if(this.currentLangId){
          this.langIdHidden.value = this.currentLangId;
        }
      }

      if(this.calendarWrapper){
        this.calendarWrapper.classList.remove('hidden');
      }

      this.initializeFlatpickr();

      this.dateHeaders.forEach((el) => {
        el.classList.remove('hidden');
      });
    }
    else {
      const checkedTicketLang = this.wrapper.querySelector('[name=lang_id]:checked');
      if(checkedTicketLang){
        this.currentLangId = checkedTicketLang.value;
      }
    }
  }

  initializeFlatpickr(){
    const _this = this;

    if(this.calendarWrapper) this.calendarWrapper.classList.add('loading-spinner', 'super-tiny-spinner', 'set-min-height-10');

    flatpickr.localize(flatpickrLanguages[document.body.dataset.lang.substr(0, 2)]);
    this.initDates(function(dates) {
      _this.currentDates = dates;
      _this.flatpickrDate = flatpickr(_this.datepicker, {
        altInput: true,
        altFormat: "l, M J, Y",
        dateFormat: "Y-m-d",
        enable: _this.getEnabledDates(),
        // defaultDate: _this.defaultDate,
        // minDate: new Date(),
        disableMobile: true,
        inline: true,
        onMonthChange: function(selectedDates, dateStr, instance) {
          const rContainer = _this.flatpickrDate.calendarContainer.querySelector('.flatpickr-rContainer');
          if(rContainer) rContainer.classList.add('loading');

          _this.currentYear = instance.currentYear;
          _this.currentMonth = instance.currentMonth + 1;

          // const unavailableMonthContainer = _this.flatpickrDate.calendarContainer.querySelector('.month-unavailable');
          // check if we need to display this month as unavailable or not
          // if(_this.currentIteration > 0) {
          //   if (_this.currentYear > _this.nextYearAvailable) {
          //     unavailableMonthContainer.classList.remove('active');
          //   } else if (_this.currentYear === _this.nextYearAvailable && _this.currentMonth >= _this.nextMonthAvailable) {
          //     // do not display
          //     unavailableMonthContainer.classList.remove('active');
          //   } else {
          //     // display
          //     unavailableMonthContainer.classList.add('active');
          //   }
          // }

          _this.fetchDates(function() {
            instance.set('enable', _this.getEnabledDates());

            if(rContainer) rContainer.classList.remove('loading');
          });

          if(_this.timeslotsContainer && _this.slotChosen && _this.bookingAuto && _this.dateHeaders.length && _this.nextDayDiv){
            _this.timeslotsContainer.innerHTML = '';
            _this.slotId.value = '';
            _this.slotChosen.value = '';
            _this.bookingAuto.value = '';
            _this.dateHeaders.forEach((el) => {
              el.innerHTML = '';
            });
            _this.nextDayDiv.innerHTML = '';

            _this.selectedSlotLabel = null;
            _this.clearSlotDerivedLangDisplay();
            _this.syncLangIdHiddenAfterSlotCleared();

            _this.setContinueBtnsDisabled(true);

            if(_this.departurePointsSection){
              _this.departurePointsSection.classList.add('hidden');
              _this.uncheckDeparturePoints();
            }

            _this.updateCartRecap();
          }
        },
        // onDayCreate: function(dObj, dStr, fp, dayElem){
        //   let year = dayElem.dateObj.getFullYear();
        //   let month = ("0" + (dayElem.dateObj.getMonth() + 1)).slice(-2)
        //   let day = ("0" + dayElem.dateObj.getDate()).slice(-2);

        //   if(_this.bookedAtLeastOnceDates[`${year}-${month}-${day}`]){
        //     dayElem.classList.add('booked-at-least-once');
        //   }
        // },
        onChange: function(selectedDates, dateStr) {
          if(selectedDates.length > 0) {
            _this.handleDateChange(selectedDates[0]);
          }
        },
        onReady: function(selectedDates, dateStr, instance) {
          setTimeout(() => {
            if(_this.calendarWrapper) _this.calendarWrapper.classList.remove('loading-spinner', 'super-tiny-spinner', 'set-min-height-10');
          }, 300);

          let enabledDates = _this.getEnabledDates();
          if(enabledDates.length){
            const firstDateAvailable = new Date(enabledDates[0]);
            firstDateAvailable.setHours(0,0,0);
            instance.setDate(firstDateAvailable, true);
          }
        }
      });

      // if(_this.currentIteration > 0) {
      //   const currentDate = new Date(_this.nextYearAvailable, _this.nextMonthAvailable-1);
      //   const flatpickrContainer = _this.flatpickrDate.calendarContainer.querySelector('.flatpickr-rContainer');
      //   const divElement = document.createElement('div');
      //   divElement.classList.add('month-unavailable', 'active');
      //   const divExplanation = document.createElement('div');
      //   const text = document.createTextNode(_this.wrapper.dataset.textBookedUntil.replace('{0}', capitalize(currentDate.toLocaleDateString('default', {month: 'long'}))));
      //   const button = document.createElement('button');
      //   button.type = 'button';
      //   button.innerText = _this.wrapper.dataset.textView.replace('{0}', capitalize(currentDate.toLocaleDateString(undefined, {month: 'long'})));
      //   button.addEventListener('click', function () {
      //     divElement.classList.remove('active');
      //     _this.flatpickrDate.changeYear(_this.nextYearAvailable);
      //     _this.flatpickrDate.changeMonth(_this.nextMonthAvailable - 1, false);
      //   });
      //   divExplanation.appendChild(text);
      //   divExplanation.appendChild(button);
      //   divElement.appendChild(divExplanation);
      //   flatpickrContainer.append(divElement);
      // }

      _this.setPrice();
      _this.wrapper.classList.remove('loading');
    });
  }

  setupEvents() {
    const _this = this;

    this.langOptions.forEach((lang) => {
      lang.addEventListener('change', () => {
        _this.handleLangChange(lang.value);
      });
    });

    this.adultspicker.addEventListener('change', function() {
      _this.handleChangeAdult(this.value);
    });

    if(this.childrenpicker) {
      _this.childrenpicker.addEventListener('change', function () {
        _this.handleChangeChild(this.value);
      });
    }

    if(this.infantsPicker){
      this.infantsPicker.addEventListener('change', () => {
        this.setPrice();
        this.updateCartRecap();
      });
    }
  }

  //use only when debounced (to not overload with ajax calls)
  updateFlatpickrWithNewPersons(){
    //to trigger manually the OnMonthChange event of flatpickr (see above)
    this.flatpickrDate.changeYear(this.currentYear);
    this.flatpickrDate.changeMonth(this.currentMonth -  1, false);
  }

  handleChangeAdult(newValue) {
    if(this.childrenpicker) {
      this.childrenpicker.max = this.maxPersons - newValue;
    }

    this.currentAdults = parseInt(newValue);
    this.setPrice();
    this.updateVisitorsNumber();
    this.updateCartRecap();

    if(!this.isTicket && this.currentLangId){
      const _this = this;
      this.fetchDates(function() {
        _this.flatpickrDate.set('enable', _this.getEnabledDates());
      });

      this.debouncedRefetchTimeslots();
    }
  }

  updateVisitorsNumber() {
    if(this.visitorsNumber) {
      this.visitorsNumber.innerHTML = this.wrapper.dataset.textVisitorsNumber.replace('{n_b}', this.currentChildren + this.currentAdults);
    }
  }

  handleChangeChild(newValue) {
    this.adultspicker.max = this.maxPersons - newValue;

    this.currentChildren = parseInt(newValue);
    this.setPrice();
    this.updateVisitorsNumber();
    this.updateCartRecap();

    if(!this.isTicket && this.currentLangId){
      const _this = this;
      this.fetchDates(function() {
        _this.flatpickrDate.set('enable', _this.getEnabledDates());
      });

      this.debouncedRefetchTimeslots();
    }
  }

  handleLangChange(newValue) {
    this.currentLangId = newValue;

    if(this.langIdHidden){
      if(newValue === 'any'){
        this.langIdHidden.value = '';
      }
      else {
        this.langIdHidden.value = newValue;
      }
    }

    this.clearSlotDerivedLangDisplay();
    this.updateCartRecap();

    if(this.isTicket){
      this.setContinueBtnsDisabled(false);
      return;
    }

    const _this = this;

    if(!this.flatpickrDate){
      this.initializeFlatpickr();
    }
    else {
      this.fetchDates(function() {
        _this.flatpickrDate.set('enable', _this.getEnabledDates());
      });

      this.debouncedRefetchTimeslots();
    }
  }

  resetCalendarAndSlot() {
    this.flatpickrDate.clear();

    this.clearSpecificPricingData();
    this.updateVisitorsPriceDisplay();

    if(this.timeslotsContainer && this.dateHeaders.length){
      this.timeslotsContainer.innerHTML = '';
      this.dateHeaders.forEach((el) => {
        el.innerHTML = '';
      });
    }

    this.setContinueBtnsDisabled(true);

    if(this.departurePointsSection){
      this.departurePointsSection.classList.add('hidden');
      this.uncheckDeparturePoints();
    }

    this.selectedSlotLabel = null;
    this.clearSlotDerivedLangDisplay();
    this.syncLangIdHiddenAfterSlotCleared();
    this.updateCartRecap();
  }

  clearSlotDerivedLangDisplay() {
    this.selectedSlotLangSvg = null;
    this.selectedSlotLangName = null;
  }

  syncLangIdHiddenAfterSlotCleared() {
    if(!this.langIdHidden){
      return;
    }

    if(this.currentLangId === 'any'){
      this.langIdHidden.value = '';
    }
    else if(this.currentLangId){
      this.langIdHidden.value = this.currentLangId;
    }
  }

  getLangNameById(langId) {
    const input = this.wrapper.querySelector(`[name="${this.mainLangIdName}"][data-lang-id="${langId}"]`);
    if(!input || String(input.dataset.langId) === '0'){
      return '';
    }

    const label = input.nextElementSibling;
    return label?.querySelector('.lang-name')?.textContent?.trim() || '';
  }

  escapeHtmlAttr(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;');
  }

  /**
   * Updates the pricing due to the potentially specific timeslot pricing.
   *
   * @param {Array} timeslots - The timeslots to update the pricing for.
   * @return {void}
   */
  updatePricingDueToSpecificTimeslots(timeslots){
    this.clearSpecificPricingData();

    // take the first slot, because specific timeslot pricing is the same for all day anyway
    const timeslot = timeslots[0];

    if(timeslot.pricing.use_group_pricing){
      if(Array.isArray(timeslot.pricing.groups_pricing) && timeslot.pricing.groups_pricing.length > 0){
        this.wrapper.dataset.specificTimeslotGroupsPricing = JSON.stringify(timeslot.pricing.groups_pricing);

        if(timeslot.pricing.host_currency_conversion_rate){
          this.hostCurrencyConversionRate = Number(timeslot.pricing.host_currency_conversion_rate);
        }
      }
    }
    else{
      this.wrapper.dataset.specificTimeslotPriceAdult = timeslot.pricing.adult_price_with_tax * 100;
      this.wrapper.dataset.specificTimeslotPriceChild = timeslot.pricing.child_price_with_tax * 100;
      this.wrapper.dataset.specificTimeslotPriceInfant = timeslot.pricing.infant_price_with_tax * 100;
    }

    this.setPrice();

    // also update the pricing under the adults/children/infants input fields
    this.updateVisitorsPriceDisplay();
  }

  /**
   * Clears the specific timeslot pricing data from the dataset.
   */
  clearSpecificPricingData(){
    delete this.wrapper.dataset.specificTimeslotGroupsPricing;
    delete this.wrapper.dataset.specificTimeslotPriceAdult;
    delete this.wrapper.dataset.specificTimeslotPriceChild;
    delete this.wrapper.dataset.specificTimeslotPriceInfant;
  }

  /**
   * Updates the unit price display for adults, children, and infants.
   * Uses specific timeslot pricing if available, otherwise falls back to default.
   */
  updateVisitorsPriceDisplay(){
    ['Adult', 'Child', 'Infant'].forEach(type => {
      const displayElements = this[`${type.toLowerCase()}PriceDisplays`];
      if(displayElements && displayElements.length > 0){
        const price = this.getUnitPriceInHostCurrency(type);
        if(price !== undefined){
          const formattedPrice = this.formatVisitorPrice(this.convertHostToVisitor(price));

          displayElements.forEach(el => el.innerHTML = formattedPrice);
        }
      }
    });
  }

  setPrice(){
    let priceInHostCurrency = 0;
    if(!this.isFree) {
      if(this.useGroupPricing){
        priceInHostCurrency = this.setGroupPrice();
      }
      else{
        priceInHostCurrency = this.setRegularPrice();
      }

      return; // TODO > REMOVE
      this.total.innerHTML = this.formatVisitorPrice(this.convertHostToVisitor(priceInHostCurrency));
    }
  }

  setRegularPrice(){
    let price = 0;

    let adultPrice = this.wrapper.dataset.priceAdult;
    let childPrice = this.wrapper.dataset.priceChild;
    let infantPrice = this.wrapper.dataset.priceInfant;

    if(this.wrapper.hasAttribute('data-specific-timeslot-price-adult')){
      adultPrice = this.wrapper.dataset.specificTimeslotPriceAdult;
    }
    if(this.wrapper.hasAttribute('data-specific-timeslot-price-child')){
      childPrice = this.wrapper.dataset.specificTimeslotPriceChild;
    }
    if(this.wrapper.hasAttribute('data-specific-timeslot-price-infant')){
      infantPrice = this.wrapper.dataset.specificTimeslotPriceInfant;
    }

    if (this.childrenpicker) {
      price = ((this.adultspicker.value * adultPrice) + (this.childrenpicker.value * childPrice)) / 100;
    }
    else {
      price = ((this.adultspicker.value * adultPrice)) / 100;
    }

    if(this.infantsPicker){
      price += ((this.infantsPicker.value * infantPrice)) / 100;
    }

    return price;
  }

  setGroupPrice(){
    let totalPersons = Number(this.adultspicker.value);
    if(this.childrenpicker) totalPersons += Number(this.childrenpicker.value);
    if(this.infantsPicker) totalPersons += Number(this.infantsPicker.value);

    if(this.wrapper.hasAttribute('data-specific-timeslot-groups-pricing')){
      this.groupsPrices = JSON.parse(this.wrapper.dataset.specificTimeslotGroupsPricing);
    } else {
      this.groupsPrices = this.defaultGroupsPrices;
    }

    let price = 0;
    for(const group of this.groupsPrices){
      if(totalPersons >= group.from_persons && totalPersons <= group.to_persons){
        if(group.price !== undefined && group.price !== null){
          price = Number(group.price);
        }
        else if(group.price_in_euros && this.hostCurrencyConversionRate){
          price = Number(group.price_in_euros) * this.hostCurrencyConversionRate;
        }
        else if(group.price_in_euros && this.wrapper.dataset.hostCurrencyConversionRate){
          price = Number(group.price_in_euros) * Number(this.wrapper.dataset.hostCurrencyConversionRate);
        }
        break;
      }
    }

    return price;
  }

  hasCurrencyConversion(){
    return this.wrapper.dataset.hostCurrency !== this.wrapper.dataset.visitorCurrencyIsoCode;
  }

  getHostToVisitorRate(){
    const rate = Number(this.wrapper.dataset.hostCurrencyRate || 1);
    return Number.isFinite(rate) && rate > 0 ? rate : 1;
  }

  convertHostToVisitor(amount){
    const price = Number(amount || 0);
    return this.hasCurrencyConversion() ? price * this.getHostToVisitorRate() : price;
  }

  formatVisitorPrice(amount){
    const locale = (this.wrapper.dataset.visitorCurrencyLocale || 'en_US').replace('_', '-');
    const currency = this.wrapper.dataset.visitorCurrencyIsoCode || 'EUR';
    return amount.toLocaleString(locale, { style: 'currency', currency: currency, minimumFractionDigits: 2 });
  }

  formatHostPrice(amount){
    const locale = (this.wrapper.dataset.hostCurrencyLocale || this.wrapper.dataset.visitorCurrencyLocale || 'en_US').replace('_', '-');
    const currency = this.wrapper.dataset.hostCurrency || 'EUR';
    return amount.toLocaleString(locale, { style: 'currency', currency: currency, minimumFractionDigits: 2 });
  }

  formatPrice(amount){
    return this.formatVisitorPrice(amount);
  }

  /**
   * Adults + children + infants.
   *
   * @returns {number}
   */
  getCartRecapHeadcount() {
    const adults = parseInt(this.adultspicker.value) || 0;
    const children = this.childrenpicker ? parseInt(this.childrenpicker.value) || 0 : 0;
    const infants = this.infantsPicker ? parseInt(this.infantsPicker.value) || 0 : 0;

    return adults + children + infants;
  }

  /**
   * Departure point surcharge in host major units (not cents).
   * `data-pricing-type`: `per_group` = x1, `per_person` = x headcount (incl. infants).
   *
   * @param {HTMLInputElement|null} input
   * @returns {number}
   */
  getDeparturePointSurchargeInHostCurrency(input) {
    if (!input) {
      return 0;
    }

    const priceHost = Number(input.dataset.priceInHostCurrency || 0);
    if (priceHost <= 0) {
      return 0;
    }

    const quantity = input.dataset.pricingType === 'per_group'
      ? 1
      : this.getCartRecapHeadcount();

    return priceHost * quantity;
  }

  getUnitPriceInHostCurrency(type){
    let price = Number(this.wrapper.dataset[`price${type}`] || 0) / 100;

    if(this.wrapper.hasAttribute(`data-specific-timeslot-price-${type.toLowerCase()}`)){
      price = Number(this.wrapper.dataset[`specificTimeslotPrice${type}`] || 0) / 100;
    }

    return price;
  }

  updateCartTotalDisplay(totalInHostCurrency, hasPriceLines){
    const canDisplayTotal = totalInHostCurrency !== null && totalInHostCurrency >= 0 && hasPriceLines;
    const showHostCurrencyLine = canDisplayTotal && this.hasCurrencyConversion();

    if(this.cartTotalAmount){
      this.cartTotalAmount.textContent = canDisplayTotal
        ? this.formatVisitorPrice(this.convertHostToVisitor(totalInHostCurrency))
        : '-';
    }

    if(this.cartTotalVisitorLabel){
      this.cartTotalVisitorLabel.classList.toggle('hidden', !showHostCurrencyLine);
    }

    if(this.cartHostTotalLine){
      this.cartHostTotalLine.classList.toggle('hidden', !showHostCurrencyLine);
    }

    if(this.cartHostTotalAmount){
      this.cartHostTotalAmount.textContent = canDisplayTotal
        ? this.formatHostPrice(totalInHostCurrency)
        : '-';
    }

    if(this.cartCurrencyNotice){
      this.cartCurrencyNotice.classList.toggle('hidden', !showHostCurrencyLine || this.isFree);
    }
  }

  updateCartRecap(){
    if(!this.cartRecap) return;

    if(this.cartDateText){
      if(this.selectedSlotLabel && this.currentDate && this.flatpickrDate){
        const selectedDate = this.flatpickrDate.selectedDates[0];

        if(selectedDate){
          const dateOptions = { year: 'numeric', month: 'short', day: 'numeric' };
          const locale = (this.wrapper.dataset.visitorCurrencyLocale || 'en_US').replace('_', '-');
          const formattedDate = selectedDate.toLocaleDateString(locale, dateOptions);
          this.cartDateText.textContent = `${formattedDate} ${this.selectedSlotLabel}`;
        }
      }
      else {
        this.cartDateText.textContent = this.cartRecap.dataset.textSelectDate;
      }
    }

    if(this.cartLangText){
      const cartLangIcon = document.querySelector('#cart-lang-icon');
      const checkedMain = this.wrapper.querySelector(`[name=${this.mainLangIdName}]:checked`);

      if(checkedMain){
        const isAnyEmbedLang = !this.isTicket && checkedMain.value === 'any';

        if(isAnyEmbedLang){
          if(this.selectedSlotLangSvg){
            if(cartLangIcon) cartLangIcon.classList.add('hidden');
            let html = `<img src="${this.escapeHtmlAttr(this.selectedSlotLangSvg)}" alt="" class="flag flag-sm mr-2" width="20">`;
            if(this.selectedSlotLangName){
              html += `<span>${this.escapeHtmlAttr(this.selectedSlotLangName)}</span>`;
            }

            this.cartLangText.innerHTML = html;
            this.cartLangText.classList.add('flex', 'items-center');
          }
          else {
            if(cartLangIcon) cartLangIcon.classList.remove('hidden');

            this.cartLangText.textContent = this.cartRecap.dataset.textSelectLanguage;
            this.cartLangText.classList.remove('flex', 'items-center');
          }
        }
        else {
          const langLabel = checkedMain.nextElementSibling;
          const flagImg = langLabel ? langLabel.querySelector('.flag img') : null;
          const langName = langLabel ? langLabel.querySelector('.lang-name')?.textContent?.trim() : '';

          if(cartLangIcon) cartLangIcon.classList.add('hidden');

          let html = '';
          if(flagImg) html += `<img src="${flagImg.src}" class="flag flag-sm mr-2" width="20">`;
          html += `<span>${langName}</span>`;
          this.cartLangText.innerHTML = html;
          this.cartLangText.classList.add('flex', 'items-center');
        }
      }
      else {
        if(cartLangIcon) cartLangIcon.classList.remove('hidden');
        this.cartLangText.textContent = this.cartRecap.dataset.textSelectLanguage;
        this.cartLangText.classList.remove('flex', 'items-center');
      }
    }

    if(this.cartVisitorsLines){
      const adults = parseInt(this.adultspicker.value) || 0;
      const children = this.childrenpicker ? parseInt(this.childrenpicker.value) || 0 : 0;
      const infants = this.infantsPicker ? parseInt(this.infantsPicker.value) || 0 : 0;

      let html = '';
      let totalInHostCurrency = 0;

      if(this.useGroupPricing){
        const groupPriceInHostCurrency = this.setGroupPrice();

        const totalPersons = adults + children + infants;
        html += `<div class="flex justify-between items-center py-1">
          <span>${totalPersons} ${totalPersons > 1 ? this.cartRecap.dataset.textPersons : this.cartRecap.dataset.textPerson}</span>
          <span>${this.formatVisitorPrice(this.convertHostToVisitor(groupPriceInHostCurrency))}</span>
        </div>`;

        totalInHostCurrency = groupPriceInHostCurrency;
      }
      else {
        const adultUnitPrice = this.getUnitPriceInHostCurrency('Adult');
        const childUnitPrice = this.getUnitPriceInHostCurrency('Child');
        const infantUnitPrice = this.getUnitPriceInHostCurrency('Infant');

        const adultTotal = adults * adultUnitPrice;
        const childTotal = children * childUnitPrice;
        const infantTotal = infants * infantUnitPrice;

        if(adults > 0){
          html += `<div class="flex justify-between items-center py-1">
            <span>${adults} ${adults > 1 ? this.cartRecap.dataset.textAdults : this.cartRecap.dataset.textAdult}</span>
            <span>${this.formatVisitorPrice(this.convertHostToVisitor(adultTotal))}</span>
          </div>`;
        }

        if(children > 0){
          html += `<div class="flex justify-between items-center py-1">
            <span>${children} ${children > 1 ? this.cartRecap.dataset.textChildren : this.cartRecap.dataset.textChild}</span>
            <span>${this.formatVisitorPrice(this.convertHostToVisitor(childTotal))}</span>
          </div>`;
        }

        if(infants > 0){
          html += `<div class="flex justify-between items-center py-1">
            <span>${infants} ${infants > 1 ? this.cartRecap.dataset.textInfants : this.cartRecap.dataset.textInfant}</span>
            <span>${this.formatVisitorPrice(this.convertHostToVisitor(infantTotal))}</span>
          </div>`;
        }

        totalInHostCurrency = adultTotal + childTotal + infantTotal;
      }

      this.cartVisitorsLines.innerHTML = html;

      let departureSurchargeInHostCurrency = 0;
      if (
        this.hasDeparturePoints
        && this.departurePointsSection
        && this.cartDepartureLine
        && this.cartDepartureLabel
        && this.cartDeparturePrice
      ) {
        const checkedDeparture = this.departurePointsSection.querySelector('input[name="departure_point"]:checked');
        if (checkedDeparture) {
          departureSurchargeInHostCurrency = this.getDeparturePointSurchargeInHostCurrency(checkedDeparture);
          this.cartDepartureLabel.textContent = checkedDeparture.dataset.addressLine;
          this.cartDeparturePrice.textContent = departureSurchargeInHostCurrency > 0
            ? `+ ${this.formatVisitorPrice(this.convertHostToVisitor(departureSurchargeInHostCurrency))}`
            : '';
          this.cartDepartureLine.classList.remove('hidden');
        }
        else {
          this.cartDepartureLabel.textContent = '';
          this.cartDeparturePrice.textContent = '';
          this.cartDepartureLine.classList.add('hidden');
        }
      }

      totalInHostCurrency += departureSurchargeInHostCurrency;
      this.updateCartTotalDisplay(totalInHostCurrency, html !== '');
    }
  }

  handleDateChange(date) {
    // set current date from datepicker value
    this.currentDate = this.datepicker.value;

    // update timeslots
    this.updateTimeslots(date, true);
  }

  /**
   * Scroll inside this document only. scrollIntoView() can scroll the host page to move the iframe — avoid it in the embed.
   */
  scrollElementInIframe(element, verticalAlign) {
    if (!element) {
      return;
    }

    const offsetTopPx = 80;
    const elRect = element.getBoundingClientRect();
    const elTop = elRect.top;
    const elHeight = elRect.height;

    const tryScroll = (container) => {
      if (!container) {
        return false;
      }

      const style = window.getComputedStyle(container);

      if (!/^(auto|scroll|overlay)$/.test(style.overflowY)) {
        return false;
      }

      if (container.scrollHeight <= container.clientHeight + 1) {
        return false;
      }

      const cRect = container.getBoundingClientRect();
      let delta = elTop - cRect.top;

      if (verticalAlign === 'center') {
        delta -= (container.clientHeight - elHeight) / 2;
      }
      else {
        delta -= offsetTopPx;
      }

      container.scrollTo({
        top: Math.max(0, container.scrollTop + delta),
        behavior: 'smooth'
      });

      return true;
    };

    if (tryScroll(element.closest('.booking-layout'))) {
      return;
    }

    if (tryScroll(element.closest('.modal-container'))) {
      return;
    }

    const root = document.scrollingElement || document.documentElement;

    if (root.scrollHeight <= root.clientHeight + 1) {
      return;
    }

    let nextY = window.pageYOffset + elTop;

    if (verticalAlign === 'center') {
      nextY -= (window.innerHeight - elHeight) / 2;
    }
    else {
      nextY -= offsetTopPx;
    }

    window.scrollTo({
      top: Math.max(0, nextY),
      behavior: 'smooth'
    });
  }

  scrollTimeslotsContainerIntoView() {
    this.scrollElementInIframe(this.timeslotsContainer, 'start');
  }

  updateTimeslots(date, scrollAfterLoad = false) {
    // check if we have all information we need to make the request
    if(this.currentDate !== null && this.currentDate !== '' && this.currentLangId !== null) {
      // get available time slots
      // make ajax request
      const _this = this;
      if(this.slotsLoading) this.slotsLoading.classList.add('active');
      if(this.timeslotsContainer) this.timeslotsContainer.classList.add('loading-spinner', 'super-tiny-spinner', 'set-min-height-10');

      ajax(`/api/experience/${this.experienceId}/timeslots?date=${this.currentDate}&adults=${this.currentAdults}&children=${this.currentChildren}&languages=${this.currentLangId}`, function(data) {
        if(_this.timeslotsContainer) _this.timeslotsContainer.classList.remove('loading-spinner', 'super-tiny-spinner', 'set-min-height-10');

        if(_this.timeslotsContainer && _this.slotChosen){
          _this.timeslotsContainer.innerHTML = '';
          _this.timeslotsContainer.scrollTop = 0;
          _this.slotChosen.value = '';
          _this.slotId.value = '';
          _this.bookingAuto.value = '';

          _this.setContinueBtnsDisabled(true);

          if(_this.departurePointsSection){
            _this.departurePointsSection.classList.add('hidden');
            _this.uncheckDeparturePoints();
          }

          _this.selectedSlotLabel = null;
          _this.clearSlotDerivedLangDisplay();
          _this.syncLangIdHiddenAfterSlotCleared();
          _this.updateCartRecap();
        }

        if (!data.timeslots || data.timeslots.length === 0) {
          if (_this.timeslotsContainer) {
            _this.timeslotsContainer.appendChild(_this.buildNoTimeslotsNotice());
          }
          if (_this.dateHeaders.length) {
            _this.dateHeaders.forEach((el) => {
              el.textContent = '';
            });
          }
        }
        else {
          // _this.wrapperNotAvailableText.classList.add('hidden');

          // do we need to update the pricing due to the specific pricing on the timeslot?
          _this.updatePricingDueToSpecificTimeslots(data.timeslots);

          const slotRows = [];
          if(_this.currentLangId === 'any'){
            data.timeslots.forEach((timeslot) => {
              const langs = timeslot.slot_languages || [];
              if(langs.length === 0){
                slotRows.push({ timeslot, slotLang: null });
              }
              else {
                langs.forEach((slotLang) => {
                  slotRows.push({ timeslot, slotLang });
                });
              }
            });
          }
          else {
            data.timeslots.forEach((timeslot) => {
              slotRows.push({ timeslot, slotLang: null });
            });
          }

          slotRows.forEach((row, index) => {
            if(_this.timeslotsContainer){
              _this.timeslotsContainer.innerHTML += _this.buildEmbedSlotDiv(row.timeslot, index === slotRows.length - 1, row.slotLang);
            }
          });

          if(_this.timeslotsContainer){
            const allSlots = _this.wrapper.querySelectorAll('.chooseSlot');
            if(allSlots){
              allSlots.forEach((chosedSlot) => {
                chosedSlot.addEventListener('click', () => {
                  _this.slotId.value = chosedSlot.dataset.slotId;
                  _this.slotChosen.value = chosedSlot.dataset.startAt;
                  _this.bookingAuto.value = chosedSlot.dataset.bookingAuto;
                  _this.selectedSlotLabel = `${chosedSlot.dataset.startAt} - ${chosedSlot.dataset.endAt}`;
                  if(_this.langIdHidden && chosedSlot.dataset.langId){
                    _this.langIdHidden.value = chosedSlot.dataset.langId;
                  }
                  _this.selectedSlotLangSvg = chosedSlot.dataset.langFlagSvg || null;
                  _this.selectedSlotLangName = chosedSlot.dataset.langName || null;
                  _this.updateCartRecap();

                  if(_this.departurePointsSection){
                    _this.departurePointsSection.classList.remove('hidden');
                    _this.scrollElementInIframe(_this.departurePointsSection, 'center');
                    _this.bindDeparturePointsForContinue();
                  }
                  else {
                    _this.setContinueBtnsDisabled(false);
                  }
                });
              });
            }
            // _this.buildNextDayButton();
          }

          //don't do it the first time so the user can still have a view on persons & langs input
          //scroll only when this fetch was triggered by a calendar date change (not lang / visitors / debounced refetch)
          if(_this.scrollToTimeSlotsContainer && scrollAfterLoad){
            _this.scrollTimeslotsContainerIntoView();
          }

          if(!_this.scrollToTimeSlotsContainer){
            _this.scrollToTimeSlotsContainer = true;
          }

          if (_this.dateHeaders.length) {
            const headerCount = _this.currentLangId === 'any'
              ? slotRows.length
              : data.timeslots.length;
            const headerText = _this.buildDateHeaderText(headerCount, date);
            _this.dateHeaders.forEach((el) => {
              el.textContent = headerText;
            });
          }
        }

        if (_this.slotsLoading) {
          _this.slotsLoading.classList.remove('active');
        }
      });
    }
  }

  /**
   * Builds the line above the timeslots list: count + formatted date, singular/plural from the DOM.
   * Uses `data-date-header-text-singular` and `data-date-header-text-plural` on `.date-header`
   *
   * @param {number} timeslotCount
   * @param {Date} date
   * @returns {string}
   */
  buildDateHeaderText(timeslotCount, date) {
    const source = this.wrapper.querySelector('.date-header');
    if (!source) {
      return '';
    }

    const localeDateOptions = { weekday: 'long', month: 'short', day: 'numeric' };
    const formattedDate = date.toLocaleDateString(
      document.body.dataset.lang.replace('_', '-'),
      localeDateOptions
    );
    const template = timeslotCount === 1
      ? source.dataset.dateHeaderTextSingular
      : source.dataset.dateHeaderTextPlural;

    return (template || '')
      .replace('{0}', String(timeslotCount))
      .replace('{1}', formattedDate);
  }

  /**
   * Notice shown when no timeslots are returned for the current date, party size and language.
   *
   * @returns {HTMLSpanElement}
   */
  buildNoTimeslotsNotice() {
    const notice = document.createElement('p');
    notice.className = 'text-sm text-me-red text-center';
    notice.textContent = this.wrapper.dataset.textNoTimeslot || '';

    return notice;
  }

  buildEmbedSlotDiv(timeslot, isLast = false, slotLang = null){
    const spotsLeftTemplate = this.timeslotsContainer.dataset.spotsLeftText || this.timeslotsContainer.dataset.spotsLeft || '{0} spots left';
    const spotsLeftText = spotsLeftTemplate.replace('{0}', timeslot.seats_rest);

    let slotLangEffective = slotLang;
    if(!slotLangEffective && timeslot.slot_languages && timeslot.slot_languages.length){
      slotLangEffective = timeslot.slot_languages.find((l) => String(l.id) === String(this.currentLangId))
        || timeslot.slot_languages[0];
    }

    let flagSvg = '';
    let langIdForCart = '';
    let langDisplayName = '';

    if(slotLangEffective){
      flagSvg = slotLangEffective.svg_url || '';
      langIdForCart = String(slotLangEffective.id);
      langDisplayName = this.getLangNameById(slotLangEffective.id);
    }
    else if(timeslot.selected_slot_language_url){
      flagSvg = timeslot.selected_slot_language_url;
      if(timeslot.slot_languages && timeslot.slot_languages[0]){
        langIdForCart = String(timeslot.slot_languages[0].id);
        langDisplayName = this.getLangNameById(timeslot.slot_languages[0].id);
      }
    }

    let flag = '';
    if(flagSvg){
      flag = `<span class="flag flag-xs-plus mx-2 flex-shrink-0"><img src="${flagSvg}" width="32" class="flag flag-sm mb-px" alt=""/></span>`;
    }

    // Calculate and format the price for this timeslot
    let priceInHostCurrency = 0;
    if(!this.isFree) {
      if(this.useGroupPricing){
        priceInHostCurrency = this.setGroupPrice();
      }
      else{
        priceInHostCurrency = this.setRegularPrice();
      }
    }

    const formattedPrice = this.formatVisitorPrice(this.convertHostToVisitor(priceInHostCurrency));

    const seatsRatio = timeslot.seats_max > 0 ? timeslot.seats_rest / timeslot.seats_max : 1;
    let spotsClass = 'spots-ok';
    if(seatsRatio < 0.1){
      spotsClass = 'spots-danger';
    }
    else if(seatsRatio < 0.5){
      spotsClass = 'spots-warning';
    }

    const slotInputId = `embed-slot-${timeslot.id}-${langIdForCart || '0'}`;

    return `
      <div class="${isLast ? '' : 'mb-3'}">
        <input type="radio" id="${slotInputId}" name="embed-slot-choice" class="timeslot-choice-radio hidden">
        <label for="${slotInputId}"
               class="timeslot-block chooseSlot flex items-center border p-4 rounded-2xl cursor-pointer"
               data-start-at="${timeslot.start}"
               data-end-at="${timeslot.end}"
               data-booking-auto="${timeslot.booking_auto}"
               data-slot-id="${timeslot.id}"
               data-lang-id="${this.escapeHtmlAttr(langIdForCart)}"
               data-lang-flag-svg="${this.escapeHtmlAttr(flagSvg)}"
               data-lang-name="${this.escapeHtmlAttr(langDisplayName)}"
        >
          <div class="flex flex-col">
            <div class="flex items-center">
              <span class="mr-2 font-semibold text-base">${timeslot.start}</span>
              ${flag}
              <div class="items-center hidden lg:flex timeslot-block__spots-left ${spotsClass} text-xs ml-3 mr-4 px-3 py-1 rounded-2xl">
                <i class="icon icon-users text-xs"></i>
                <span class="ml-1">${timeslot.seats_rest}/${timeslot.seats_max}</span>
              </div>
            </div>

            <div class="lg:hidden flex items-center mt-1">
              <span class="text-gray-800 font-semibold mr-3">${formattedPrice}</span>
              <span class="timeslot-block__spots-left-text ${spotsClass} flex items-center">
                <i class="icon icon-users text-sm"></i>
                <span class="ml-1">${spotsLeftText}</span>
              </span>
            </div>
          </div>

          <div class="circle ml-auto flex justify-center items-center w-8 h-8 border rounded-full leading-none flex-shrink-0">
            <i class="icon icon-simple-check text-xs"></i>
          </div>
        </label>
      </div>
    `;
  }

  // highlightCurrentSlot(allSlots, chosedSlot){
  //   allSlots.forEach((slot) => {
  //     slot.classList.toggle('timeslot-block--selected', slot.dataset.slotId === chosedSlot.dataset.slotId);
  //   });

  //   if(chosedSlot.control){
  //     chosedSlot.control.checked = true;
  //   }
  // }

  bindDeparturePointsForContinue(){
    if(this._departurePointsBound) return;
    this._departurePointsBound = true;

    const departureInputs = this.departurePointsSection.querySelectorAll('input[name="departure_point"]');
    departureInputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.setContinueBtnsDisabled(false);
        this.updateCartRecap();
      });
    });

    this.updateCartRecap();
  }

  uncheckDeparturePoints(){
    if(!this.departurePointsSection) return;

    const checkedDP = this.departurePointsSection.querySelectorAll('input[name="departure_point"]:checked');
    checkedDP.forEach((input) => { input.checked = false; });
  }

  setContinueBtnsDisabled(disabled){
    this.continueBtns.forEach(btn => { btn.disabled = disabled; });
  }

  initContinueButton(){
    if(!this.continueBtns.length) return;

    this.continueBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        if(btn.disabled) return;

        if(btn.classList.contains('load-extras')){
          Modal.toggleModal('#pickExtras', false);
          document.dispatchEvent(new Event('modal-opened'));
        }
      });
    });
  }

  // buildNextDayButton(){
    // const _this = this;

  //   let currentDay = this.wrapper.querySelector('.flatpickr-day.selected');
  //   if(currentDay){
  //     let nextDay = null;
  //     let checkLimit = 0;
  //     while(!nextDay && checkLimit < 30){
  //       if(currentDay && currentDay.nextSibling && !currentDay.nextSibling.classList.contains('flatpickr-disabled')){
  //         nextDay = currentDay.nextSibling;
  //         break;
  //       }

  //       if(currentDay) currentDay = currentDay.nextSibling;
  //       checkLimit++;
  //     }

      // if(nextDay){
        // const localeDateOptions = { weekday: 'long', month: 'short', day: 'numeric' };
        // let nextDayDate = this.flatpickrDate.selectedDates[0];
        // nextDayDate.setDate(nextDay.textContent);
        // const seeNextDayHTML = `
        //   <div class="flex items-center justify-center">
        //     <button class="btn border border-gray-300 px-12 py-2" type="button" id="checkNextDay">
        //       ${this.timeslotsContainer.dataset.seeNextDay.replace('{0}', nextDayDate.toLocaleDateString(document.body.dataset.lang.replace('_', '-'), localeDateOptions))}
        //     </button>
        //   </div>
        // `;

        // this.nextDayDiv.innerHTML = seeNextDayHTML;
      //   const seeNextDayButton = this.wrapper.querySelector('#checkNextDay');
      //   if(seeNextDayButton){
      //     seeNextDayButton.addEventListener('click', () => {
      //       _this.flatpickrDate.setDate(nextDayDate, true);
      //     });
      //   }
      // }
      // else this.nextDayDiv.innerHTML = '';
  //   }
  // }

  //Check if a day is booked at least once on one of its timeslots
  bookedAtLeastOnce(date){
    let res = false;
    date.time_slots.forEach((slot) => {
      if(slot.seats_count > 0){
        res = true;
        return;
      }
    });

    return res;
  }

  getEnabledDates() {
    // const _this = this;

    const enabledDates = this.currentDates.filter((date) => {
      // if(!date.close && this.bookedAtLeastOnce(date)){
      //   _this.bookedAtLeastOnceDates[date.date_format] = true;
      // }
      return !date.close;
    });

    // check if 0 enabled dates
    if(enabledDates.length === 0) {
      // return false to disable all dates
      return [function() {
        return false;
      }];
    }

    return enabledDates.map((date) => {
      return date.date_format;
    });
  }

  getRawEnabledDates() {
    const enabledDates = this.currentDates.filter((date) => {
      return !date.close;
    });

    return enabledDates.map((date) => {
      return date.date_format;
    });
  }

  fetchDates(callback) {
    const _this = this;
    callback = callback || function(){};

    if(this.ajaxRequestRunning) {
      this.ajaxRequest.abort();
    }

    this.ajaxRequestRunning = true;
    this.ajaxRequest = ajax(this.wrapper.dataset.datesUrl + `?month=${this.currentMonth}&year=${this.currentYear}&lang_id=${this.currentLangId}&adults=${this.currentAdults}&children=${this.currentChildren}`, function(data) {
      _this.currentDates = data.dates;
      callback(data.dates);
      _this.ajaxRequestRunning = false;
    });
  }

  initDates(callback) {
    const _this = this;
    callback = callback || function(){};

    ajax(this.wrapper.dataset.datesUrl + `?month=${this.currentMonth}&year=${this.currentYear}&lang_id=${this.currentLangId}&adults=${this.currentAdults}&children=${this.currentChildren}`, function(data) {
      _this.currentDates = data.dates;
      let enabledDates = _this.getRawEnabledDates();
      if(enabledDates.length === 0 && _this.currentIteration < _this.maxIterations) {
        if(_this.currentMonth === 12) {
          _this.currentMonth = 1;
          _this.currentYear++;
        } else {
          _this.currentMonth = _this.currentMonth + 1;
        }
        _this.currentIteration++;
        _this.initDates(callback);
        return;
      }

      _this.nextMonthAvailable = _this.currentMonth;
      _this.nextYearAvailable = _this.currentYear;

      callback(data.dates);
    });
  }
}

export default BookingProcess;
